import axios from 'axios';
import API_CONFIG from '../config/api';
import { translateVi } from '../i18n/LocaleContext';

const API_URL = API_CONFIG.getApiUrl('/referral-admin');

const getAuthHeader = () => {
  const token = localStorage.getItem('token');
  return {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  };
};

export const referralAdminService = {
  // Lấy danh sách users được giới thiệu
  getUsers: async (page = 1, limit = 10, search = '') => {
    try {
      const response = await axios.get(`${API_URL}/users?page=${page}&limit=${limit}&search=${search}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy danh sách users'));
    }
  },

  // Lấy chi tiết user
  getUserDetail: async (userId) => {
    try {
      const response = await axios.get(`${API_URL}/users/${userId}`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy thông tin user'));
    }
  },

  // Lấy thống kê
  getStats: async () => {
    try {
      const response = await axios.get(`${API_URL}/stats`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy thống kê'));
    }
  },

  // Cộng/trừ tiền cho user
  adjustBalance: async (userId, amount, type) => {
    try {
      const response = await axios.post(`${API_URL}/users/${userId}/adjust-balance`, { amount, type }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể điều chỉnh số dư'));
    }
  },

  // Set VIP cho user
  setUserVip: async (userId, vip) => {
    try {
      const response = await axios.put(`${API_URL}/users/${userId}/vip`, { vip }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể cập nhật VIP'));
    }
  },

  // Điều chỉnh số dư user
  adjustBalance: async (userId, amount, action) => {
    try {
      const response = await axios.post(`${API_URL}/users/${userId}/adjust-balance`, { amount, action }, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể điều chỉnh số dư'));
    }
  },

  // Khóa/mở khóa user
  toggleUserLock: async (userId) => {
    try {
      const response = await axios.put(`${API_URL}/users/${userId}/lock`, {}, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể khóa/mở khóa user'));
    }
  },

  // Get bonus orders
  getBonusOrders: async (userId) => {
    try {
      const response = await axios.get(`${API_URL}/users/${userId}/bonus-orders`, getAuthHeader());
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể lấy bonus orders'));
    }
  },

  // Set bonus order (with file upload)
  setBonusOrder: async (userId, position, imageFile, productPrice) => {
    try {
      const formData = new FormData();
      formData.append('position', position);
      formData.append('productPrice', productPrice);
      formData.append('image', imageFile);

      const response = await axios.post(`${API_URL}/users/${userId}/set-bonus-order`, formData, {
        ...getAuthHeader(),
        headers: {
          ...getAuthHeader().headers,
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể set bonus order'));
    }
  },

  // Delete bonus order
  deleteBonusOrder: async (userId, position) => {
    try {
      const response = await axios.delete(`${API_URL}/users/${userId}/delete-bonus-order`, {
        ...getAuthHeader(),
        data: { position }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.error || translateVi('Không thể xóa bonus order'));
    }
  }
};
